import React from 'react'

import { StructureControls, InputControls } from './Controls'

const NetworkControls = ({
    network,
    setNetworkOutput,
    dataset,
    inputs,
    setInputs,
    setLoss,
    expectedOutputs,
  }) => {
  return (
    <div>
      <h2>Inference</h2>

      <h3>Inputs</h3>
      <InputControls
        inputs={inputs}
        setInputs={setInputs}
        network={network}
        setNetworkOutput={setNetworkOutput}
        setLoss={setLoss}
        expectedOutputs={expectedOutputs}
        dataset={dataset}
      ></InputControls>
    </div>
  )
}

const NetworkOptions = ({
  options,
  setOptions
}) => {
  const handleOptionChange = e => {
    var newOptions = structuredClone(options)
    newOptions[e.target.dataset.option] = e.target.checked
    console.log(e.target.checked)
    setOptions(newOptions)
  }

  return (
    <div>
      <h2>Options</h2>
      <input
        type="checkbox"
        id="cbEnableTraining"
        checked={options.training}
        data-option="training"
        onChange={handleOptionChange}
      ></input>
      <label>Enable Training</label>
    </div>
  )
}

export {
  NetworkControls,
  NetworkOptions
}